import React, {Component} from "react";
import {Modal, Header, Button, Icon, Form} from "semantic-ui-react";
import PropTypes from "prop-types";

export class InfosheetEditDialog extends Component {
  state = {
    infosheetId: this.props.identifier,
    description: this.props.description,
    priority: this.props.priority
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.props.identifier !== prevProps.identifier) this.setState({
      infosheetId: this.props.identifier,
      description: this.props.description,
      priority: this.props.priority
    });
  }

  handleChange = (e, {name, value}) => { this.setState({[name]: value})}

  render = () => {
    const { description, priority} = this.state;

    return (
      <Modal open={this.props.open}>
        <Header icon={'edit outline'} color={'blue'} content={'Edit Infosheet Metadata'}/>
        <Modal.Content>
          <Form id={'infosheet-edit-form'} size='large'>
            <Form.Input
              name={'description'}
              label={'Description'}
              value={description}
              onChange={this.handleChange}
            />
            <Form.Input
              name={'priority'}
              label={'Priority'}
              value={priority}
              type={'number'}
              step={10}
              onChange={this.handleChange}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button name={'noBtn'} color='red' inverted onClick={this.props.onNoClick}>
            <Icon name='cancel'/> Cancel
          </Button>
          <Button name={'yesBtn'} color='green' inverted onClick={() => this.props.onYesClick(this.state)}>
            <Icon name='checkmark'/> OK
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

};

InfosheetEditDialog.propTypes = {
  open: PropTypes.bool,
  identifier: PropTypes.string,
  description: PropTypes.string,
  priority: PropTypes.number,
  onYesClick: PropTypes.func,
  onNoClick: PropTypes.func
};